import { useRemoteConfig } from "@/hooks/remoteConfig/useRemoteConfig";

type Options = {
  // true only for AU users on the signup Address step
  reportFailures?: boolean;
};

const useIsPhoneVerificationEnabled = (options?: Options) => {
  const { loading, value } = useRemoteConfig(
    "api_config_mobileVerificationEnabled",
    options,
  );

  return { loading, isEnabled: !loading && (value?.asBoolean() ?? true) };
};

export { useIsPhoneVerificationEnabled };
